import React, {useState, useEffect, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PURPLE} from "../../../constants/general-constants";
import {useHistory} from 'react-router-dom';

export default function UtilisationOutliers({}){
	
	const history = useHistory();
	
	const thisContainer = {
		display:'flex',
		flexGrow:"1",
		marginLeft:"20px",
		height:"80px",
		width:"calc(100% - 20px)"
	};
	
	const outlierBox = {
		display:"flex",
		width:"calc(31% - 20px)",
		marginTop:"20px",
		marginLeft:"20px",
		height:"100px",
		borderRadius:"10px",
		flexDirection:"column",
		cursor:'pointer'
	};
	
	const boxTitleContainer = {
		display:"flex",
		width:"100%",
		height:"30px",
		color:'white',
		fontSize:'14px',
		alignItems:"center",
		justifyContent:"space-around"
	};
	
	const boxTitleCode = {
		display:"flex",
		width:"100%",
		height:"40px",
		color:'white',
		fontSize:'21px',
		alignItems:"center",
		justifyContent:"space-around"
	};
	
	const boxTitleDescription = {
		display:"flex",
		width:"100%",
		height:"40px",
		color:'white',
		fontSize:'12px',
		alignItems:"center",
		justifyContent:"space-around"
	};
	
	const outlierLink = {
		display:"flex",
		width:"100%",
		height:"100%",
		color:'white',
		fontSize:'14px',
		alignItems:"center",
		justifyContent:"space-around",
		cursor:"pointer"
	};
	
	const goUtilisationRoom = () => {
  	history.push('/utilisationroom');
  };
	
	return (
		<div style={thisContainer}>
			<div style={{...outlierBox, backgroundColor:'darkred'}} onClick={goUtilisationRoom}>
				<div style={boxTitleContainer}>
					Least Used
				</div>
				<div style={boxTitleCode}>
					WS786
				</div>
				<div style={boxTitleDescription}>
					Floor 3 Room 8
				</div>
			</div>
			<div style={{...outlierBox, backgroundColor:'darkgreen'}}>
				<div style={boxTitleContainer}>
					Most Used
				</div>
				<div style={boxTitleCode}>
					PD56
				</div>
				<div style={boxTitleDescription}>
					Floor 3 West Pod
				</div>
			</div>
			<div style={{...outlierBox, backgroundColor:'#444'}}>
				<div style={outlierLink}>
					<u>View All Outliers</u>
				</div>
			</div>
		</div>
	);
}